var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 42,
    viewBox: "0 0 34 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 40.2008C17.2749 40.6184 17.2751 40.6183 17.2753 40.6182L17.2761 40.6177L17.2787 40.6159L17.2882 40.6096L17.3239 40.5858C17.355 40.5649 17.4007 40.5341 17.4598 40.4936C17.5782 40.4126 17.7507 40.2929 17.9695 40.1366C18.4073 39.8239 19.0309 39.3644 19.7785 38.7746C21.2729 37.5954 23.2667 35.8921 25.2622 33.7955C29.2335 29.6232 33.3 23.8014 33.3 17.4008C33.3 13.2549 31.4379 9.13712 28.5655 6.05962L28.5536 6.04723C25.4571 2.95072 21.3287 1.30078 17 1.30078C12.6713 1.30078 8.54297 2.95072 5.44646 6.04723L5.43448 6.05962C2.56215 9.13712 0.700012 13.2549 0.700012 17.4008C0.700012 23.7023 4.76784 29.5244 8.73681 33.7194C10.7318 35.828 12.7251 37.5499 14.219 38.7444C14.9664 39.342 15.5898 39.8084 16.0273 40.1261C16.2461 40.2849 16.4185 40.4067 16.5368 40.489C16.5959 40.5302 16.6415 40.5616 16.6726 40.5828L16.7083 40.6071L16.7177 40.6135L16.7203 40.6152L16.7211 40.6157C16.7213 40.6159 16.7215 40.616 17 40.2008ZM17 40.2008L17.2749 40.6184C17.1068 40.7291 16.8886 40.7282 16.7215 40.616L17 40.2008ZM17 23.5008C13.6762 23.5008 10.9 20.7246 10.9 17.4008C10.9 14.0968 13.6559 11.5008 17 11.5008C20.3239 11.5008 23.1 14.2769 23.1 17.6008C23.1 20.9048 20.3441 23.5008 17 23.5008Z",
    fill: "#33894E",
    stroke: "#136B2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationAddress);
export default __webpack_public_path__ + "static/media/location_address.3e5b965767fefabcc3341e476d24c71b.svg";
export { ForwardRef as ReactComponent };